import { tv } from "../../../variants/tv.js";
const trVariants = tv({
    base: 'bg-neutral-1',
    variants: {
        striped: {
            true: 'even:bg-neutral-3/30'
        },
        sticky: {
            true: 'border-b-1 border-primary-5',
            false: ''
        },
        tableBordered: {
            true: '',
            false: ''
        },
        isHeaderRow: {
            true: '',
            false: ''
        },
        color: {
            none: '',
            success: 'bg-success-3',
            error: 'bg-error-3',
            neutral: 'bg-neutral-3/30',
            caution: 'bg-caution-3'
        },
        highlightOnHover: {
            true: '',
            false: ''
        }
    },
    compoundVariants: [
        {
            striped: false,
            tableBordered: true,
            isHeaderRow: false,
            class: 'nth-last-1:*:border-b-0'
        },
        {
            striped: false,
            isHeaderRow: false,
            color: 'none',
            highlightOnHover: true,
            class: 'hover:bg-neutral-2 active:bg-primary-3'
        },
        {
            striped: true,
            highlightOnHover: true,
            class: 'hover:bg-neutral-4 hover:text-neutral-11 active:bg-primary-3'
        },
        {
            color: 'success',
            highlightOnHover: true,
            class: 'hover:bg-success-4 active:bg-primary-3'
        },
        {
            color: 'error',
            highlightOnHover: true,
            class: 'hover:bg-error-4 active:bg-primary-3'
        },
        {
            color: 'neutral',
            highlightOnHover: true,
            class: 'hover:bg-neutral-4 active:bg-primary-3'
        },
        {
            color: 'caution',
            highlightOnHover: true,
            class: 'hover:bg-caution-4 active:bg-primary-3'
        }
    ],
    defaultVariants: {
        tableBordered: false,
        sticky: false,
        striped: false,
        isHeaderRow: false,
        color: 'none',
        highlightOnHover: true,
        isGroupHeader: false
    }
});
export { trVariants };
